import { render, staticRenderFns } from "./FieldMapping.vue?vue&type=template&id=12686d10"
import script from "./FieldMapping.vue?vue&type=script&lang=js"
export * from "./FieldMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports